import { nanoid } from 'nanoid';
import { Confirm } from './types';
import { dispatch } from './store';

type ConfirmInput = Pick<
  Confirm,
  | 'title'
  | 'desc'
  | 'confirmText'
  | 'dismissText'
  | 'color'
  | 'confirmButtonProps'
  | 'dismissButtonProps'
  | 'dialogProps'
  | 'closeEventType'
> &
  (
    | {
        type?: 'normal';
      }
    | {
        type: 'confirmText';
        confirmTextList: string[];
        confirmTextInputPlaceholder: string;
        confirmTextErrorMessage: string;
      }
  ) & {
    id?: string;
  };

const confirm = async (opts: ConfirmInput) => {
  return new Promise<void>((resolve, reject) => {
    const confirmId = opts.id ?? nanoid();
    const confirm = {
      id: confirmId,
      title: opts.title,
      desc: opts.desc,
      dismissText: opts.dismissText,
      confirmText: opts.confirmText,
      color: opts.color,
      closeEventType: opts.closeEventType,
      onConfirm: () => {
        dispatch({ type: 'REMOVE_CONFIRM', confirmId });
        resolve();
      },
      onDismiss: () => {
        dispatch({ type: 'REMOVE_CONFIRM', confirmId });
        reject();
      },
      confirmButtonProps: opts.confirmButtonProps,
      dismissButtonProps: opts.dismissButtonProps,
      dialogProps: opts.dialogProps,
      type: 'normal',
      ...(opts.type === 'confirmText' && {
        type: 'confirmText',
        confirmTextList: opts.confirmTextList,
        confirmTextErrorMessage: opts.confirmTextErrorMessage,
        confirmTextInputPlaceholder: opts.confirmTextInputPlaceholder,
      }),
    } as Confirm;

    dispatch({ type: 'ADD_CONFIRM', confirm });
    return confirm.id;
  });
};

export default confirm;
